var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', _vm._g({
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "width": "24",
      "height": "24"
    }
  }, _vm.$listeners), [_c('g', {
    attrs: {
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12.003.522C5.673.522.523 5.672.523 12.003s5.15 11.481 11.48 11.481c6.332 0 11.482-5.15 11.482-11.48 0-6.332-5.15-11.482-11.482-11.482"
    }
  }), _c('path', {
    attrs: {
      "stroke": "#005149",
      "stroke-width": "1.044",
      "d": "M12.003.522C5.673.522.523 5.672.523 12.003s5.15 11.481 11.48 11.481c6.332 0 11.482-5.15 11.482-11.48 0-6.332-5.15-11.482-11.482-11.482z"
    }
  }), _c('path', {
    attrs: {
      "fill": "#005149",
      "stroke": "#E0EEE8",
      "stroke-width": ".4",
      "d": "m11.671 6.66.06.001c.699 0 1.272-.55 1.301-1.252.028-.732-.55-1.329-1.313-1.36A1.303 1.303 0 0 0 10.423 5.3c-.03.72.53 1.33 1.248 1.36m1.282 1.822H9.759v1.152h1.425v9.169H9.887v1.152h4.361v-1.152h-1.297z"
    }
  })])]);

}
var staticRenderFns = []

export { render, staticRenderFns }